import { formatDate } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-print-order-byfurgation-report',
  standalone: false,
  templateUrl: './print-order-byfurgation-report.component.html',
  styleUrl: './print-order-byfurgation-report.component.scss'
})
export class PrintOrderByfurgationReportComponent {
  // implements OnChanges {

  // @Input() printOrderData: any

  newValue: any
  newValue1: any
  abhikartaData = [
    {
      "mode": "विक्री",
      "name": "हस्ते",
      "prati": 0
    },
    {
      "mode": "जादा विक्री",
      "name": "थेट",
      "prati": 0
    }

  ]
  jadaAnkData = [
    {
      "mode": "पार्सल जादा अंक",
      "prati": 0,
      "checkboxShow": false
    },
    {
      "mode": "अनामत जादा ",
      "prati": 0,
      "checkboxShow": false
    },
    {
      "mode": "पेंडींग जादा अंक ",
      "prati": 0,
      "checkboxShow": false
    }
  ]

  karyalayData = [
    // {
    //   "mode": "प्रतिनिधी अभिकर्ता सप्रेम भेट",
    //   "prati": 0,
    //   "checkboxShow": false,
    //   "abhikartaValue": 0,
    //   "abhikartaPreValue": 0,
    // },
    {
   "mode": "अभिकर्ता सप्रेम भेट",
      "prati": 0,
      "checkboxShow": false,
      "abhikartaValue": 0,
      "abhikartaPreValue": 0,
  }, {
      "mode": "प्रतिनिधी सप्रेम भेट",
      "prati": 0,
      "checkboxShow": false,
      "abhikartaValue": 0,
      "abhikartaPreValue": 0,
    },
     {
      "mode": "संपादकीय सप्रेम भेट",
      "prati": 0,
      "checkboxShow": false,
      "abhikartaValue": 0,
      "abhikartaPreValue": 0,
    },
    {
      "mode": "जाहिरात सप्रेम भेट",
      "prati": 0,
      "checkboxShow": false,
      "abhikartaValue": 0,
      "abhikartaPreValue": 0,
    }, {
      "mode": "कार्यालय सप्रेम भेट",
      "prati": 0,
      "checkboxShow": false,
      "abhikartaValue": 0,
      "abhikartaPreValue": 0,
    }, {
      "mode": "कार्यालय (फाईल )",
      "prati": 0,
      "checkboxShow": false
    }
  ]
  // jadaAnkData: any = [{ "mode": "", "prati": 0 }]
  varganidarTotal: number = 0
  jadaAnkTotal: number = 0
  supremBhetTotal: number = 0
  abhikartaTotal: number = 0
  lengthOfList: Number = 0
  middleIndex: any = 0

  lengthOfSapremBhet: Number = 0
  middleIndexSapremBhet: any = 0
  constructor(private dialogref: MatDialogRef<PrintOrderByfurgationReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService) {

  }
  districtwiseData: any
  districtwiseSapremBhetData: any
  sundayankDate: any
  dispatchankDate: any
  total_sub_count = 0;
  totalparcel = 0;
  totalanksankhya = 0;
  filtereddistrictwisesubcout = [];
  disRepData = [];
  // type: any;
  state: any
  district: any
  distributionMode: any
  subDistributionMode: any
  country: any
  updateStatus: any
  issuedate: any
  deleveryModeList: any = []
  subscribeTypes: any = []
  dataTemp: any
  districtWiseData: any = []
  sapremBhet: any = [{ "mode": "", "prati": 0 }]
  lengthOfkaryalay: number = 0;
  indexOfKaryalay: number = 0
  endDate: any
  startDate: any
  lengthOfVarganidar: number = 0
  middleIndexVarganidar: number = 0
  formattedDate: any
  publishDate: any
  previousDataList: any
//   ngOnInit(): void {

//     this.districtwiseSapremBhetData = this.data['data'];
//     this.sundayankDate = this.data['sundaydate'];
//     this.dispatchankDate = this.data['dispatchdate'];
//     this.publishDate = this.data['publishDate'];
//     // this.type = this.data['type']
//     // this.updateStatus = this.data['updateStatus']
//     this.issuedate = this.data['issuedate']
//     this.state = this.data.state;
//     this.district = this.data.district;
//     this.country = this.data.country;
//     this.distributionMode = this.data.distributionMode;
//     this.deleveryModeList = this.data.deleveryModeList
//     this.subscribeTypes = this.data.subscribeTypes
//     this.districtwiseData = this.data.districtWiseData;
//     this.formattedDate = this.convertToMarathiDate(this.issuedate)

//     this.lengthOfkaryalay = Number(this.karyalayData.length);
//     this.indexOfKaryalay = Math.floor(this.karyalayData.length / 2);

//     this.districtwiseData = this.districtwiseData.filter(item => item.delivery_mode !== "डिजिटल");
//     this.deleveryModeList = this.deleveryModeList.filter(item => item.mode_name && item.mode_name.trim() !== "" && item.mode_name !== "डिजिटल");
//     for (let i = 0; i < this.deleveryModeList.length; i++) {
//       let value = this.calculation(this.deleveryModeList[i].mode_name, this.districtwiseData);
//       let value1 = this.calculation(this.deleveryModeList[i].mode_name, this.districtwiseSapremBhetData);
//       this.deleveryModeList[i].prati = Number(value) - Number(value1);
//       this.deleveryModeList[i].prati1 = Number(value);
//       this.varganidarTotal = Number(this.varganidarTotal) + Number(this.deleveryModeList[i].prati);

//     }
//     this.lengthOfVarganidar = Number(this.deleveryModeList.length);
//     this.middleIndexVarganidar = Math.floor(this.deleveryModeList.length / 2);




//     /////////////////Varganidar section end and JADA ANK Section start////////////////////////
//     this.service.getPrintOrderByfurgationList(this.issuedate, this.country[0]).subscribe((res) => {
//       this.dataTemp = res;
//       this.previousDataList = this.dataTemp[0].RECORDS;
//       this.jadaAnkData.forEach((item, index) => {
//         if (item.mode == "पार्सल जादा अंक") {
//           item.prati = this.dataTemp[0].TOTAL_JADA_VALUE || 0
//         }
//         this.jadaAnkTotal = Number(this.jadaAnkTotal) + Number(item.prati);
//       });
//       this.jadaAnkData.push({
//         mode: " ",
//         prati: 0,
//         checkboxShow: false
//       });
//       this.lengthOfList = Number(this.jadaAnkData.length);
//       this.middleIndex = Math.floor(this.jadaAnkData.length / 2);

//       ////////////////////////////abhikarta starts/////////////////////////////

//       this.abhikartaData.forEach((item, index) => {
//         if (item.mode == "विक्री") {
//           item.prati = this.dataTemp[0].ISSUE_SELLER_COPY || 0
//         }
//         this.abhikartaTotal = Number(this.abhikartaTotal) + Number(item.prati);
//       });
//       let otherKaryalayTotal = 0
//       this.karyalayData.forEach((item, index) => {
//         // if (item.mode == "प्रतिनिधी अभिकर्ता सप्रेम भेट") {
//         //   item.prati = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//         //   item.abhikartaValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//         //   item.abhikartaPreValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//         // }

//         if (item.mode == "अभिकर्ता सप्रेम भेट") {
//           item.prati = this.dataTemp[0].ABHIKARTA_TOTAL || 0
//           item.abhikartaValue = this.dataTemp[0].ABHIKARTA_TOTAL || 0
//           item.abhikartaPreValue = this.dataTemp[0].ABHIKARTA_TOTAL || 0
//         }
        
//         // if (item.mode == "प्रतिनिधी सप्रेम भेट") {
//         //   item.prati = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//         //   // item.abhikartaValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//         //   item.abhikartaPreValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//         // }

//         if (item.mode == "प्रतिनिधी सप्रेम भेट") {
//           const totalPrati = Number(this.dataTemp[0]?.TOTAL_PRATI_ABHIKARTA_VALUE) || 0;
//           const abhikartaTotal = Number(this.dataTemp[0]?.ABHIKARTA_TOTAL) || 0;
//           item.abhikartaPreValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0

//           item.prati = totalPrati - abhikartaTotal;
//           item.abhikartaValue = abhikartaTotal;
//           item.abhikartaPreValue = totalPrati - abhikartaTotal;
//         }


//         if (item.mode == "कार्यालय सप्रेम भेट" || item.mode == "संपादकीय सप्रेम भेट" || item.mode == "जाहिरात सप्रेम भेट") {
//           item.prati = this.getByFurgationObject(item.mode) != undefined ? this.getByFurgationObject(item.mode).prati : 0;
//           otherKaryalayTotal = otherKaryalayTotal + Number(item.prati);
//         }

//       });
//       // this.karyalayData.forEach((item, index) => {
//       //   // if (item.mode == "प्रतिनिधी अभिकर्ता सप्रेम भेट") {
//       //   //   item.prati = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //   //   item.abhikartaValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //   //   item.abhikartaPreValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //   // }

//       //    if (item.mode == "अभिकर्ता सप्रेम भेट") {
//       //     item.prati = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //     item.abhikartaValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //     // item.abhikartaPreValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //   }
//       //    if (item.mode == "प्रतिनिधी सप्रेम भेट") {
//       //     item.prati = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //     // item.abhikartaValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //     item.abhikartaPreValue = this.dataTemp[0].TOTAL_PRATI_ABHIKARTA_VALUE || 0
//       //   }
//       //   this.karyalayTotal = Number(this.karyalayTotal) + Number(item.prati);
//       // });

//       this.karyalayData.forEach((item, index) => {
//   if (item.mode == "अभिकर्ता सप्रेम भेट") {
//     const abhikartaTotal = Number(this.dataTemp[0]?.ABHIKARTA_TOTAL) || 0;

//     item.prati = abhikartaTotal;
//     item.abhikartaValue = abhikartaTotal;
//   }

//  if (item.mode == "प्रतिनिधी सप्रेम भेट") {
//   const totalPrati = Number(this.dataTemp[0]?.TOTAL_PRATI_ABHIKARTA_VALUE) || 0;
//   const abhikartaTotal = Number(this.dataTemp[0]?.ABHIKARTA_TOTAL) || 0;

//    item.prati = totalPrati - abhikartaTotal;   
//   item.abhikartaValue = abhikartaTotal;       
//   item.abhikartaPreValue = totalPrati - abhikartaTotal; 
//    console.log(
//     `प्रतिनिधी सप्रेम भेट → totalPrati: ${totalPrati}, abhikartaTotal: ${abhikartaTotal}, abhikartaPreValue: ${item.abhikartaPreValue}`
//   );
// }


//   this.karyalayTotal = Number(this.karyalayTotal) + Number(item.prati);
// });
//     });



//     //////////////////////////////////////////सप्रेम भेट/////////////////////////////////
//     this.sapremBhet = [];
//     for (let i = 0; i < this.subscribeTypes.length; i++) {
//       let value = this.calculation1(this.subscribeTypes[i], this.districtwiseSapremBhetData);
//       this.sapremBhet.push({
//         mode: this.subscribeTypes[i],
//         prati: value
//       });
//       this.supremBhetTotal = Number(this.supremBhetTotal) + Number(this.sapremBhet[i].prati);

//     }
//     this.sapremBhet.push({
//       mode: " ",
//       prati: 0
//     });
//     this.lengthOfSapremBhet = Number(this.sapremBhet.length);
//     this.middleIndexSapremBhet = Math.floor(this.sapremBhet.length / 2);

//     /////////////////JADA ANK section end start abhikarta ////////////////////////
//     // this.printorderData = this.data['data'];
//     this.endDate = this.data['issuedate'];
//     let weekfirstday =
//       new Date(this.data['issuedate']).getDate() -
//       new Date(this.data['issuedate']).getDay();
//     this.startDate = formatDate(
//       new Date(this.data['issuedate']).setDate(weekfirstday - 6),
//       'yyyy-MM-dd',
//       'en-IN',
//       'GMT+0530'
//     );
//     this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)
//   }

ngOnInit(): void {

  this.districtwiseSapremBhetData = this.data['data'];
  this.sundayankDate = this.data['sundaydate'];
  this.dispatchankDate = this.data['dispatchdate'];
  this.publishDate = this.data['publishDate'];
  this.issuedate = this.data['issuedate']
  this.state = this.data.state;
  this.district = this.data.district;
  this.country = this.data.country;
  this.distributionMode = this.data.distributionMode;
  this.deleveryModeList = this.data.deleveryModeList
  this.subscribeTypes = this.data.subscribeTypes
  this.districtwiseData = this.data.districtWiseData;

  this.formattedDate = this.convertToMarathiDate(this.issuedate)

  this.lengthOfkaryalay = Number(this.karyalayData.length);
  this.indexOfKaryalay = Math.floor(this.karyalayData.length / 2);

  // ✅ FILTER
  this.districtwiseData = this.districtwiseData.filter(item => item.delivery_mode !== "डिजिटल");
  this.deleveryModeList = this.deleveryModeList.filter(item =>
    item.mode_name && item.mode_name.trim() !== "" && item.mode_name !== "डिजिटल"
  );

  // ✅ RESET TOTALS FIRST
  this.varganidarTotal = 0;
  this.jadaAnkTotal = 0;
  this.abhikartaTotal = 0;
  this.karyalayTotal = 0;
  this.supremBhetTotal = 0;

  // ✅ VARGANIDAR
  for (let i = 0; i < this.deleveryModeList.length; i++) {
    let value = this.calculation(this.deleveryModeList[i].mode_name, this.districtwiseData);
    let value1 = this.calculation(this.deleveryModeList[i].mode_name, this.districtwiseSapremBhetData);

    this.deleveryModeList[i].prati = Number(value) - Number(value1);
    this.deleveryModeList[i].prati1 = Number(value);

    this.varganidarTotal += Number(this.deleveryModeList[i].prati);
  }

  this.lengthOfVarganidar = this.deleveryModeList.length;
  this.middleIndexVarganidar = Math.floor(this.deleveryModeList.length / 2);

  // ================= API CALL =================
  this.service.getPrintOrderByfurgationList(this.issuedate, this.country[0])
    .subscribe((res) => {

      this.dataTemp = res;
      this.previousDataList = this.dataTemp[0].RECORDS;

      // ✅ JADA ANK
      this.jadaAnkTotal = 0;
      this.jadaAnkData.forEach(item => {
        if (item.mode == "पार्सल जादा अंक") {
          item.prati = this.dataTemp[0].TOTAL_JADA_VALUE || 0;
        }
        this.jadaAnkTotal += Number(item.prati);
      });

      // ✅ ABHIKARTA
      this.abhikartaTotal = 0;
      this.abhikartaData.forEach(item => {
        if (item.mode == "विक्री") {
          item.prati = this.dataTemp[0].ISSUE_SELLER_COPY || 0;
        }
        this.abhikartaTotal += Number(item.prati);
      });

      // ✅ KARYALAY
      this.karyalayTotal = 0;
      this.karyalayData.forEach(item => {

        if (item.mode == "अभिकर्ता सप्रेम भेट") {
          const val = Number(this.dataTemp[0]?.ABHIKARTA_TOTAL) || 0;
          item.prati = val;
          item.abhikartaValue = val;
        }

        if (item.mode == "प्रतिनिधी सप्रेम भेट") {
          const totalPrati = Number(this.dataTemp[0]?.TOTAL_PRATI_ABHIKARTA_VALUE) || 0;
          const abhikartaTotal = Number(this.dataTemp[0]?.ABHIKARTA_TOTAL) || 0;

          item.prati = totalPrati - abhikartaTotal;
          item.abhikartaValue = abhikartaTotal;
          item.abhikartaPreValue = totalPrati - abhikartaTotal;
        }

        if (
          item.mode == "कार्यालय सप्रेम भेट" ||
          item.mode == "संपादकीय सप्रेम भेट" ||
          item.mode == "जाहिरात सप्रेम भेट"
        ) {
          item.prati = this.getByFurgationObject(item.mode)?.prati || 0;
        }

        this.karyalayTotal += Number(item.prati);
      });

      // ✅ SAPREM BHET
      this.sapremBhet = [];
      this.supremBhetTotal = 0;

      for (let i = 0; i < this.subscribeTypes.length; i++) {
        let value = this.calculation1(this.subscribeTypes[i], this.districtwiseSapremBhetData);

        this.sapremBhet.push({
          mode: this.subscribeTypes[i],
          prati: value
        });

        this.supremBhetTotal += Number(value);
      }

      // ================= FINAL TOTAL =================
      this.total =
        Number(this.krushiValue || 0) +
        Number(this.jadaAnkTotal || 0) +
        Number(this.varganidarTotal || 0) +
        Number(this.abhikartaTotal || 0) +
        Number(this.supremBhetTotal || 0) +
        Number(this.karyalayTotal || 0) +
        Number(this.jadaVarganiNew || 0);

      console.log("FINAL TOTAL:", this.total);

    });

  // ✅ DATE CALCULATION
  this.endDate = this.data['issuedate'];

  let weekfirstday =
    new Date(this.data['issuedate']).getDate() -
    new Date(this.data['issuedate']).getDay();

  this.startDate = formatDate(
    new Date(this.data['issuedate']).setDate(weekfirstday - 6),
    'yyyy-MM-dd',
    'en-IN',
    'GMT+0530'
  );
}

  @ViewChild('valueInput') valueInputRef!: ElementRef;
  setValue() {
    this.jadaAnkData[this.jadaAnkData.length - 1] = {
      mode: this.newValue,
      prati: Number(this.newValue1),
      checkboxShow: true
    };

    // Push a new empty row for next entry
    this.jadaAnkData.push({
      mode: " ",
      prati: 0,
      checkboxShow: false
    });

    this.lengthOfList = this.jadaAnkData.length;
    this.middleIndex = Math.floor(this.jadaAnkData.length / 2);
    this.jadaAnkTotal = Number(this.jadaAnkTotal) + Number(this.newValue1);
    this.newValue = "";
    this.newValue1 = "";


    setTimeout(() => {
      this.valueInputRef.nativeElement.focus();
    });
  }
  calculation(type: any, districtwiseData: any) {
    this.total_sub_count = 0;
    let tempdata = this.uniqueid(districtwiseData, (a) => a['district']);

    this.filtereddistrictwisesubcout = [];
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = districtwiseData.filter(
        (a) => a['district'] == tempdata[index]['district']
      );
      let delivery_mode_unique = this.uniqueid(arr, (a) => a['delivery_mode']);

      let totalTapalCount = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['delivery_mode'] == delivery_mode_unique[j]['delivery_mode']
        );
        if (arr1[0]['delivery_mode'] === type) {
          totalTapalCount = Object.keys(arr1).length;
        }
      }
      this.total_sub_count += totalTapalCount;
    }
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)
    return this.total_sub_count;
  }
  calculation1(type: any, districtwiseData: any) {
    let total_sub_count = 0;
    let tempdata = this.uniqueid(districtwiseData, (a) => a['district']);
    for (let index = 0; index < Object.keys(tempdata).length; index++) {
      let arr = districtwiseData.filter(
        (a) => a['district'] == tempdata[index]['district']
      );
      let delivery_mode_unique = this.uniqueid(arr, (a) => a['Subscription_Type']);

      let totalTapalCount = 0;
      for (let j = 0; j < Object.keys(delivery_mode_unique).length; j++) {
        let arr1 = arr.filter(
          (a) => a['Subscription_Type'] == delivery_mode_unique[j]['Subscription_Type']
        );
        if (arr1[0]['Subscription_Type'] === type) {
          totalTapalCount = Object.keys(arr1).length;
        }
      }
      total_sub_count += totalTapalCount;
    }
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)

    return total_sub_count;
  }
  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  deleteFromArray(obj: any) {
    this.jadaAnkTotal = 0
    this.jadaAnkData = this.jadaAnkData.filter(item => item.mode !== obj.mode);
    this.jadaAnkData.forEach((item, index) => {
      this.jadaAnkTotal = Number(this.jadaAnkTotal) + Number(item.prati);
    });
    this.lengthOfList = this.jadaAnkData.length;
    this.middleIndex = Math.floor(this.jadaAnkData.length / 2);
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew) + Number(this.extraTotal)

  }
  deleteFromSupremBhetArray(obj: any) {
    this.jadaAnkTotal = 0
    this.sapremBhet = this.sapremBhet.filter(item => item.mode !== obj.mode);
    this.sapremBhet.forEach((item, index) => {
      this.supremBhetTotal = Number(this.supremBhetTotal) + Number(item.prati);
    });
    this.lengthOfSapremBhet = this.sapremBhet.length;
    this.middleIndexSapremBhet = Math.floor(this.sapremBhet.length / 2);
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew) + Number(this.extraTotal)

  }
  karyalayTotal: any = 0
  krushiValue: any = 0
  karylayInputValue: any
  karylayInputKey: any
  @ViewChild('valueInputKaryalay') valueInputRef1!: ElementRef;
  setValueKaryalay() {
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew) + Number(this.extraTotal)

    debugger
    this.karyalayData[this.karyalayData.length - 1] = {
      mode: this.karylayInputKey,
      prati: Number(this.karylayInputValue),
      checkboxShow: true,
      abhikartaValue: 0,
      abhikartaPreValue: 0
    };

    // Push a new empty row for next entry
    this.karyalayData.push({
      mode: " ",
      prati: 0,
      checkboxShow: false,
      abhikartaValue: 0,
      abhikartaPreValue: 0
    });

    this.lengthOfkaryalay = this.karyalayData.length;
    this.indexOfKaryalay = Math.floor(this.karyalayData.length / 2);
    this.karyalayTotal = Number(this.karyalayTotal) + Number(this.karylayInputValue);
    this.karylayInputKey = "";
    this.karylayInputValue = "";


    setTimeout(() => {
      this.valueInputRef1.nativeElement.focus();
    });
  }
  deleteFromKaralayArray(obj: any) {
    this.karyalayTotal = 0
    this.karyalayData = this.karyalayData.filter(item => item.mode !== obj.mode);
    this.karyalayData.forEach((item, index) => {
      this.karyalayTotal = Number(this.karyalayTotal) + Number(item.prati);
    });
    this.lengthOfkaryalay = this.karyalayData.length;
    this.indexOfKaryalay = Math.floor(this.karyalayData.length / 2);
  }
  extraTotal: any = 0
  deleteFromExtraArray(obj: any) {
    // this.karyalayTotal = 0
    this.extraParamList = this.extraParamList.filter(item => item.mode !== obj.mode);
    this.extraParamList.forEach((item, index) => {
      this.extraTotal = Number(this.extraTotal) + Number(item.prati);
    });
    this.lengthOfExtra = this.extraParamList.length;
    this.indexOfExtra = Math.floor(this.extraParamList.length / 2);
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew) + Number(this.extraTotal)
  }
  setKrushiValue() {

  }
  inputKaralatyTotalCalculate(event: any, data: any) {
    console.log(data)
    this.karyalayTotal = 0;
    let abhikartaValue = 0;
    let object1;
    abhikartaValue = this.karyalayData.filter((x) => x.mode == "प्रतिनिधी सप्रेम भेट")[0].prati;

    // let abhikartaValue1 = this.karyalayData.filter((x) => x.mode == "प्रति अभिकर्ता")[0].abhikartaValue;
    if (Number(abhikartaValue) <= 0) {
      alert("प्रतिनिधी सप्रेम भेट value is less or equal to 0");
    }
    this.karyalayData.forEach((item, index) => {

      if (item.mode != "प्रतिनिधी सप्रेम भेट" && data.mode == item.mode) {
        if (Number(item.abhikartaPreValue) > Number(item.prati)) {
          abhikartaValue = Number(abhikartaValue) + (Number(item.abhikartaPreValue) - Number(item.prati));
        } else {
          abhikartaValue = Number(abhikartaValue) - (Number(item.prati) - Number(item.abhikartaPreValue));
        }
      }
    });
    this.karyalayData.forEach((item, index) => {
      item.abhikartaPreValue = item.prati;
      if (item.mode == "प्रतिनिधी सप्रेम भेट") {
        item.prati = Number(abhikartaValue)
        item.abhikartaValue = Number(abhikartaValue)
      }
      this.karyalayTotal = Number(this.karyalayTotal) + Number(item.prati);

    });

    this.extraParamList.forEach((item, index) => {
      this.extraTotal = Number(this.extraTotal) + Number(item.prati);

    });
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew) + Number(this.extraTotal)

  }
  

  printOrderData: any
  isFirstVisible: boolean = true;
  total: any
  toggleMethod() {
    

    this.isFirstVisible = !this.isFirstVisible
    if (!this.isFirstVisible) {

    const issuedate = new Date(this.data['issuedate']);
    issuedate.setDate(issuedate.getDate() - 6);

    this.startDate = formatDate(
      issuedate,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

      this.printOrderData = {
        endDate: this.endDate,
        startDate: this.startDate,
        varganidarTotal: this.jadaAnkTotal + this.varganidarTotal,
        abhikartaTotal: this.abhikartaTotal,
        supremBhetTotal: this.supremBhetTotal,
        total: this.total,
        jadaAnkTotal: this.jadaAnkTotal,
        krushiValue: this.krushiValue,
        karyalayData: this.karyalayData,
        jadaVarganiNew: this.jadaVarganiNew,
        extraParamList: this.extraParamList
      }
    }

  }

  closeDialog() {
    if (
      window.confirm(
        'Are you sure want to close, Please save data before close'
      )
    ) {
      this.dialogref.close();
    }
  }

  jadaVarganiCal() {
    debugger
    this.jadaAnkTotal = 0
    this.jadaAnkData.forEach((item, index) => {
      this.jadaAnkTotal = Number(this.jadaAnkTotal) + Number(item.prati);
    });
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)

  }

  abhikartaCal() {
    debugger
    this.abhikartaTotal = 0

    this.abhikartaData.forEach((item, index) => {
      this.abhikartaTotal = Number(this.abhikartaTotal) + Number(item.prati);
    });
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)

  }
  sapremBhetCal() {
    debugger
    this.supremBhetTotal = 0
    this.sapremBhet.forEach((item, index) => {
      this.supremBhetTotal = Number(this.supremBhetTotal) + Number(item.prati) + Number(this.krushiValue);
      // this.krushiVivekCal();
    });
    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)

  }
  convertToMarathiDate(dateStr: string): string {
    const marathiMonths = [
      'जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल', 'मे', 'जून',
      'जुलै', 'ऑगस्ट', 'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'
    ];

    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = marathiMonths[date.getMonth()]; // 0-based index
    const day = date.getDate(); // ✅ Correct method

    return `${day} ${month} ${year}`;
  }

  listForSave: any = []
  generateListForSave() {
    this.listForSave = []

    this.deleveryModeList.forEach(element => {
      let obj: any = {}; // or use a specific type if available
      obj.tapashil = "वर्गणीदार";
      obj.modes = element.mode_name;
      obj.prati = element.prati;
      this.listForSave.push(obj);
    });
    this.jadaAnkData.forEach(element => {
      let obj: any = {};
      obj.tapashil = "जादा वर्गणी",
        obj.modes = element.mode,
        obj.prati = element.prati
      this.listForSave.push(obj);
    });

    this.abhikartaData.forEach(element => {
      let obj: any = {};
      obj.tapashil = "अभिकर्ता",
        obj.modes = element.mode,
        obj.prati = element.prati
      this.listForSave.push(obj);
    });
    this.sapremBhet.forEach(element => {
      let obj: any = {};
      obj.tapashil = "सप्रेम भेट",
        obj.modes = element.mode,
        obj.prati = element.prati
      this.listForSave.push(obj);
    });
    this.karyalayData.forEach(element => {
      let obj: any = {};
      obj.tapashil = "कार्यालय सप्रेम भेट",
        obj.modes = element.mode,
        obj.prati = element.prati
      this.listForSave.push(obj);
    });

    let obj: any = {};
    obj.tapashil = "कृषी विवेक",
      obj.modes = "",
      obj.prati = this.krushiValue
    this.listForSave.push(obj);

    this.listForSave.forEach((element: any) => {
      element.varganidar_value = this.varganidarTotal,
        element.varganidar_total = this.jadaAnkTotal + this.varganidarTotal,
        element.jada_varganidar_total = this.jadaAnkTotal,
        element.abhikarta_total = this.abhikartaTotal,
        element.saprembhet_total = this.supremBhetTotal,
        element.karyalay_total = this.karyalayTotal,
        element.total = this.krushiValue + this.jadaAnkTotal + this.varganidarTotal + this.abhikartaTotal + this.supremBhetTotal + this.karyalayTotal
    });

  }


  saveSubscriptionBarcodesDataEntry() {
    this.generateListForSave();

    const filteredData = this.listForSave.map((item) => ({
      issue_date: this.issuedate,
      publish_date: this.publishDate,
      dispatch_date: this.convertDateFormat(this.dispatchankDate),
      country: this.country,
      modes: item.modes,
      prati: item.prati,
      varganidar_value: item.varganidar_value || 0,
      varganidar_total: item.varganidar_total || 0,
      jada_varganidar_total: item.jada_varganidar_total || 0,
      abhikarta_total: item.abhikarta_total || 0,
      saprembhet_total: item.saprembhet_total || 0,
      karyalay_total: item.karyalay_total || 0,
      total: item.total

    }));
    this.service.insertPprintOrderByFurgation(filteredData).subscribe((data) => {
      alert('Save Successfully!');
      this.toggleMethod();
    });
  }
  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    return `${year}/${month}/${day}`;
  }
  jadaVarganiNew: any = 0
  krushiVivekCal() {



    this.total = Number(this.krushiValue) + Number(this.jadaAnkTotal) + Number(this.varganidarTotal) + Number(this.abhikartaTotal) + Number(this.supremBhetTotal) + Number(this.karyalayTotal) + Number(this.jadaVarganiNew)
  }
  extraParamList: any = [{
    "name": "",
    "mode": "",
    "prati": 0
  }]
  @ViewChild('extraValuesManage') valueInputRef2!: ElementRef;
  extraValueInput: any
  extrakeyInput: any
  lengthOfExtra: number = 0
  indexOfExtra: any = 0
  extrakeyNameInput: any
  extraParamForPrintorder() {
    this.total = Number(this.total) + Number(Number(this.extraValueInput));
    debugger
    this.extraParamList[this.extraParamList.length - 1] = {
      mode: this.extrakeyNameInput,
      name: this.extrakeyInput,
      prati: Number(this.extraValueInput),
      checkboxShow: true,
      abhikartaValue: 0,
      abhikartaPreValue: 0
    };

    // Push a new empty row for next entry
    this.extraParamList.push({
      name: " ",
      mode: " ",
      prati: 0,
      checkboxShow: false,
      abhikartaValue: 0,
      abhikartaPreValue: 0
    });

    this.lengthOfExtra = this.extraParamList.length;
    this.indexOfExtra = Math.floor(this.extraParamList.length / 2);
    this.extrakeyInput = "";
    this.extraValueInput = "";
    this.extrakeyNameInput = "";


    setTimeout(() => {
      this.valueInputRef2.nativeElement.focus();
    });
  }

  getByFurgationObject(name: string): any {
    const object = this.previousDataList.find(m => m.modes === name);
    return object;
  }
}
